export const DEFAULT_IMAGE_POSTER = "@/assets/images/logo/favicon.png";

export enum MEETING_TYPE {
  WEBINAR = "WEBINAR",
  MEETING = "MEETING",
  ONE_TO_ONE = "ONE_TO_ONE",
  SPEED_NETWORKING = "SPEED_NETWORKING",
  GAME = "GAME",
  AUTO_VIDEO = "AUTO_VIDEO",
}

export enum LAYOUT_TYPE {
  //COLUMN = "COLUMN",
  GRID = "GRID",
  TOP_ROW = "TOP_ROW",
  //COLUMN_LEFT = "COLUMN_LEFT",
  // COLUMN_RIGHT = "COLUMN_RIGHT",
  COLUMN_TRANSPARENT_LEFT = "COLUMN_TRANSPARENT_LEFT",
  TOP_SHARE = "TOP_SHARE",
}
